import $ from 'jquery';

export default function setCookie (key, value, expiry=0) { // Expiry in minutes
	var now = new Date();
	var time = now.getTime();
	time += expiry * 60 * 1000;
	now.setTime(time);
	expiry = now.toUTCString();
	document.cookie = key + '=' + value + ';expires='+ expiry +';path=/;';
}